import React, { Component, Fragment } from 'react';
import CollectionFieldForm from './CollectionFieldForm';

export default class CollectionFieldRow extends Component {
  render() {
    const {
      createNewParamRow,
      fields,
      params,
      utilities,
      collectionName,
      version,
      isMultiTenantPluginInstalled,
      projectId,
      events,
    } = this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left" width="26%">
                  Field
                </td>
                <td className="text-left" width="30%">
                  Value From
                </td>
                <td className="text-left" width="22%">
                  Value
                </td>
                <td className="text-left" width="22%">
                  Action
                </td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <CollectionFieldForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    fields={fields}
                    utilities={utilities}
                    collectionName={collectionName}
                    projectId={projectId}
                    version={version}
                    isMultiTenantPluginInstalled={isMultiTenantPluginInstalled}
                    events={events}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
